import React, { useState, useEffect } from 'react';
import type ApolloClient from 'apollo-client';
import SectionMessage from '@atlaskit/section-message';

import {
	type Extension,
	GET_APP_NAME,
	type AppDetails,
	type AppDetailsQueryParams,
} from '../web-client';

interface UIKit1WarningMessageProps {
	client: ApolloClient<any>;
	extension: Extension;
}

export const UIKit1WarningMessage = (props: UIKit1WarningMessageProps) => {
	const { client, extension } = props;
	const [appName, setAppName] = useState<string | undefined>(undefined);

	useEffect(() => {
		if (client) {
			const response = client.query<AppDetails, AppDetailsQueryParams>({
				query: GET_APP_NAME,
				variables: { id: extension.id },
			});

			response.then((data) => {
				const appName = data.data?.app.name;

				setAppName(appName);
			});
		}
	}, [client, extension.id]);

	const title = appName ? appName : extension.properties.title;
	const message = `${title} version is outdated and no longer supported.\nPlease ask your admin to update it through Atlassian Administration.`;

	return (
		<SectionMessage title="App update required" appearance="warning">
			{message}
		</SectionMessage>
	);
};
